import { useCallback } from 'react'
import toast from 'react-hot-toast'
import QrReader from 'react-qr-reader'
import { useHistory } from 'react-router'
import { useGetLoginContato } from '../../../data/api/login-contato/login-contato'
import { BaixasStorageKeys, useBaixasStorage } from '../../../services/use-cases/baixas-storage'
import './scan-qrcode-page.css'

export const ScanQrCodePage = () => {

    const { getLoginContato } = useGetLoginContato()
    const { getRegister } = useBaixasStorage()
    const history = useHistory()
    const responsavel = getRegister(BaixasStorageKeys.dataRepresentante)

    const getDadosContato = useCallback(async (email, telefone) => {
        const res = await getLoginContato(email, telefone)
        if (res.erro) {
            throw res.erro
        }
        return res.resultado?.data
    }, [getLoginContato])

    const handleScan = useCallback(async (data) => {
        if (data !== null) {
            try {
                const dataSplit = data?.split("|")
                const dadosContato = await getDadosContato(dataSplit[1], dataSplit[2])
                if (dadosContato.responsavelId !== null && dadosContato.responsavelId !== responsavel.id) {
                    throw new Error(`Este contato é do Representante ${dadosContato?.responsavel?.nome}. Acesso bloqueado`)
                }

                history.push(`/representante/adicionar-contato/${data}`)
                toast.success('Contato encontrado.')
            } catch (e: any) {
                toast.error(e.message)
            }
        }
    }, [getDadosContato, history, responsavel.id])

    const handleError = (err: any) => {
        console.error(err)
    }

    return (
        <div className="scanQrCode pt-5 pb-5">
            <div className=''>
                <div className='qrcode'>
                    <QrReader
                        className="qrcode-camera"
                        delay={1000}
                        onError={handleError}
                        onScan={handleScan}
                    />
                </div>
                <button className='w-100 mt-5 btn btn-primary' onClick={() => history.push('/representante/clientes')}>
                    Voltar
                </button>
            </div>
        </div>
    )
}